module.exports = __webpack_public_path__ + "static/media/pro.b8c1e371.svg";